if (!crypto.randomUUID) {
  crypto.randomUUID = () => {
    return 'xxxxxxxx-xxxx-5xxx-txxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }
}

// Add this to your existing JavaScript
window.addEventListener('pageshow', function (event) {
  // Always refresh cart data on pageshow, regardless of persisted state
  // This ensures it works in all environments, including published themes
  fetch(`/cart.json?v=${crypto.randomUUID()}`)
    .then((response) => response.json())
    .then((cart) => {
      updateHeaderCartCount(cart.item_count)
      updateCartDrawer()
    })
    .catch((error) => console.error('Error fetching cart:', error))
})

// Additionally, listen for the 'popstate' event which fires when navigating history
window.addEventListener('popstate', function () {
  // Short timeout to ensure the page has fully transitioned
  setTimeout(() => {
    fetch(`/cart.json?v=${crypto.randomUUID()}`)
      .then((response) => response.json())
      .then((cart) => {
        updateHeaderCartCount(cart.item_count)
        updateCartDrawer()
      })
      .catch((error) => console.error('Error fetching cart:', error))
  }, 100)
})
